import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Creators as StoreByUserActions,
  selectFarmaciaManual
} from "../../store/ducks/storeByUser";
import ProductsOutOfStockModal from "../ ProductsOutOfStockModal";
import HeaderLocationDelivery from "../HeaderLocationDelivery";
import * as LuIcons from "react-icons/lu";
import {
  TopbarWrapper,
  InnerContent,
  LeftBlock,
  CenterBlock,
  RightBlock,
  BotaoPill,
  DesktopChevronWrapper,
  ChevronButton,
  ChevronDropdown,
  MobileChevronButton,
  MobileOverlay,
  MobilePopup,
} from "./styles";

export default function TopbarIdentidadeVisual() {
  const dispatch = useDispatch();
  const { data: identidade } = useSelector(state => state.identidadeVisual);
  const empresa = useSelector(state => state.store.data?.empresa);
  const { showOutOfStockModal } = useSelector(state => state.storeByUser);
  // Farmacia escolhida pelo cliente. A resolvida pelo contexto de entrega nao aparece aqui:
  // o endpoint de cobertura devolve id e uuid, sem nome_fantasia, e exibir "(limpar)" sem
  // nome faria parecer que o cliente escolheu uma farmacia que ele nunca escolheu.
  const farmaciaManual = useSelector(selectFarmaciaManual);

  const [avisoIndex, setAvisoIndex] = useState(0);
  const [avisoVisible, setAvisoVisible] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobilePopupOpen, setMobilePopupOpen] = useState(false);
  const [isMarquee, setIsMarquee] = useState(false);

  const containerRef = useRef(null);
  const textRef = useRef(null);

  const barra_avisos = identidade?.barra_avisos || [];

  useEffect(() => {
    if (barra_avisos.length <= 1) return;
    const interval = setInterval(() => {
      setAvisoVisible(false);
      setTimeout(() => {
        setAvisoIndex(prev => (prev + 1) % barra_avisos.length);
        setAvisoVisible(true);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, [barra_avisos.length]);

  useEffect(() => {
    if (textRef.current && containerRef.current) {
      setIsMarquee(textRef.current.scrollWidth > containerRef.current.clientWidth);
    }
  }, [avisoIndex]);

  useEffect(() => {
    // modalIsOpen saiu da condicao: o SelectStoreModal agora e montado pelo painel de
    // entrega, que tem a propria trava e restaura o valor anterior em vez de assumir "auto".
    document.body.style.overflow = mobilePopupOpen ? "hidden" : "auto";
  }, [mobilePopupOpen]);

  const cores = identidade?.cores || {};
  const topbar_botoes = identidade?.topbar_botoes || [];
  const visibleBotoes = topbar_botoes.slice(0, 2);
  const extraBotoes = topbar_botoes.slice(2);
  const currentAviso = barra_avisos[avisoIndex] || null;

  const getIconComponent = icon => {
    if (!icon || typeof icon !== "string") return null;

    const iconName = icon
      .trim()
      // Aceita valores que chegam com o prefixo da biblioteca, como
      // "Fibriefcase-business" ou "LuBriefcaseBusiness".
      .split(/[-_\s]+/)
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join("");

    return LuIcons[`Lu${iconName}`] || null;
  };

  return (
    <TopbarWrapper fundo={cores.topbar_fundo} texto={cores.topbar_texto}>
      {showOutOfStockModal && <ProductsOutOfStockModal />}
      <InnerContent>
        {/* ESQUERDA */}
        <LeftBlock>
          <HeaderLocationDelivery />
          {/* O icone de loja e o botao "Encontre a farmacia mais perto de voce" sairam:
              eram uma segunda entrada de localizacao ao lado do seletor, ocupando a barra
              e dividindo a mesma tarefa em dois lugares. O SelectStoreModal passa a ser
              acionado pelo link "Escolher uma farmacia especifica" no rodape do painel.

              O ramo abaixo fica. Ele nao e uma entrada de localizacao: e indicador de
              estado e a unica forma de destravar a farmacia na navegacao normal, fora da
              faixa de conflito do card. So aparece com escolha manual do cliente
              (selectFarmaciaManual exige selecionadaPeloCliente), entao farmacia resolvida
              automaticamente pelo contexto nao cai aqui com nome vazio. */}
          {farmaciaManual !== null && (
            <div className="selected">
              <span onClick={() => dispatch(StoreByUserActions.setStore(null))}>
                {farmaciaManual.nome_fantasia} {"(limpar)"}
              </span>
            </div>
          )}
        </LeftBlock>

        {/* CENTRO */}
        {currentAviso && (
          <CenterBlock ref={containerRef} fundo={cores.barra_cor_fundo} visible={avisoVisible}>
            {currentAviso.link ? (
              <a
                ref={textRef}
                href={currentAviso.link}
                target={currentAviso.link_nova_aba ? "_blank" : undefined}
                rel="noopener noreferrer"
                className={isMarquee ? "marquee-text" : ""}
              >
                {currentAviso.emoji && <span>{currentAviso.emoji} </span>}
                {currentAviso.texto}
              </a>
            ) : (
              <span
                ref={textRef}
                className={isMarquee ? "marquee-text" : ""}
              >
                {currentAviso.emoji && <span>{currentAviso.emoji} </span>}
                {currentAviso.texto}
              </span>
            )}
          </CenterBlock>
        )}

        {/* DIREITA */}
        <RightBlock>
          {topbar_botoes.length > 0 && (
            <>
              {visibleBotoes.map((botao, idx) => {
                const IconComponent = getIconComponent(botao.icone);
                return (
                  <BotaoPill
                    key={idx}
                    fundo={botao.cor_fundo}
                    texto={botao.cor_texto}
                    href={botao.link || undefined}
                    target={botao.nova_aba ? "_blank" : undefined}
                    rel={botao.link ? "noopener noreferrer" : undefined}
                    showOnMobile={topbar_botoes.length === 1}
                  >
                    {IconComponent && <IconComponent size={14} />}
                    {botao.texto}
                  </BotaoPill>
                );
              })}

              {extraBotoes.length > 0 && (
                <DesktopChevronWrapper>
                  <ChevronButton onClick={() => setDropdownOpen(o => !o)}>
                    &#9660;
                  </ChevronButton>
                  {dropdownOpen && (
                    <ChevronDropdown>
                      {extraBotoes.map((botao, idx) => (
                        <a
                          key={idx}
                          href={botao.link || "#"}
                          target={botao.link_nova_aba ? "_blank" : undefined}
                          rel="noopener noreferrer"
                        >
                          {botao.texto}
                        </a>
                      ))}
                    </ChevronDropdown>
                  )}
                </DesktopChevronWrapper>
              )}

              {topbar_botoes.length > 1 && (
                <MobileChevronButton onClick={() => setMobilePopupOpen(true)}>
                  &#9660;
                </MobileChevronButton>
              )}
            </>
          )}
        </RightBlock>
      </InnerContent>


      {mobilePopupOpen && (
        <>
          <MobileOverlay onClick={() => setMobilePopupOpen(false)} />
          <MobilePopup>
            {topbar_botoes.map((botao, idx) => {
              const IconComponent = getIconComponent(botao.icone);
              return (
                <BotaoPill
                  key={idx}
                  fundo={botao.cor_fundo}
                  texto={botao.cor_texto}
                  href={botao.link || undefined}
                  target={botao.link_nova_aba ? "_blank" : undefined}
                  rel={botao.link ? "noopener noreferrer" : undefined}
                  onClick={() => setMobilePopupOpen(false)}
                  showOnMobile
                >
                  {IconComponent && <IconComponent size={14} />}
                  {botao.texto}
                </BotaoPill>
              )
            })}
          </MobilePopup>
        </>
      )}
    </TopbarWrapper>
  );
}
